<template>
	<div class="main-view">
		<div style="margin-bottom: 10px;
					display: flex;
					flex-direction: row;
					align-items: center;">
			<!-- <span style="color: #FF8826;">1</span>-->
			<div style="font-size: 14px;
						width: 6px;
						height: 15px;
						background-color: #409eff;
						margin-right: 5px;
						border-radius: 4px;"></div> 
			<span style="margin-left: 0px;">{{ cardTitle }}（共{{  questionArr.length}}题）</span>
		</div>
		<div class="quetion-item" v-for="item,index in questionArr" :key="index"  :id="item.id">
			<div class="title-topic">
				<div class="label">
					{{ item.text }}
				</div>
				<div class="label" style="margin-top: 10px;">
					<el-tag type="info" v-for="subItem,subIndex in item.optionList" :key="subIndex" style="margin-right: 10px;">{{subItem}}</el-tag>
				</div>
				<img style="width: 50%;" mode="aspectFit" alt="" :src="item.imageUrl" v-if="item.imageUrl != null"/>
			</div>
			<div class="question-view">
				<el-input
					class="el-input"
					type="textarea"
					:rows="3"
					placeholder="请输入你的答案"
					v-model="textarea1">
				</el-input>
			</div>
			<div v-if="showAnswerFlagD && item.correctAnswer!=null" class="correctAnswer-view">正确答案：{{ item.correctAnswer.join(' ') }}</div>

		</div>
		
	</div>
</template>

<script>

import SequencingDrillApi from '@/api/src/drill/api/SequencingDrillApi'
const sequencingDrillApi = new SequencingDrillApi()
export default {
	props:['showAnswerFlag','questionData','cardTitle'],
	data(){
		return{
			section:null,
			checkList: ['选中且禁用','复选框 A'],
			radio: 3,
			textarea1: '',
			showAnswerFlagD:this.showAnswerFlag,
			questionDataArr:this.questionData,
			questionArr:[],
		}
	},
	mounted () {
		this.loadData()
	},

	watch:{
		
		showAnswerFlag(val){
			console.log("监听到变化")
			this.showAnswerFlagD = val
			this.$forceUpdate()
		},
	},
	methods:{
		radioChange(index,value){

		},
		async loadData(){
			let drillIds = this.questionDataArr.map(item => {return item.drillId})
			var body = {
				sessionTime: 0,
				idList: drillIds
			}
			var resp = await sequencingDrillApi.getDrillList(body)
			console.log('----loadData---')
			console.log(resp)
			this.questionArr = resp
		},
		formattedText(text) {
			return text;
		}
	}
}
</script>

<style lang="less" scoped>
	.main-view{
		margin: 10px;
		border-radius: 10px; /* 圆角半径10px */
		box-shadow: 0 0 10px rgba(132, 132, 132, 0.3); /* 添加阴影效果 */
		padding: 20px; /* 内边距 */
		width: 87%;
		padding-bottom: 0px;
	}

	.quetion-item{
		display: flex;
		flex-direction: column;
		border-bottom: 2px solid #dddddd;
		margin-top: 10px;
		.title-topic{
			font-size: 18px;
			margin-left: 10px;
			display: flex;
			flex-direction: column;
			.label{

			}
		}
		.question-view{
			margin-top: 10px;
			margin-bottom: 10px;
			margin-left: 10px;
			.el-input{
				width: 450px;
			}
		}
		
	}
	.correctAnswer-view{
	    margin: 0px;
		margin-top: 10px;
		color: green;
		
	}
</style>